const inputCls =
  "w-full rounded-2xl border border-earth/20 bg-cream px-5 py-3.5 text-charcoal placeholder:text-earth/40 outline-none transition-all duration-300 focus:border-terracotta focus:ring-4 focus:ring-terracotta/15";

export const Field = ({ label, testid, optional, ...props }) => (
  <label className="block" data-testid={`${testid}-wrap`}>
    <span className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-earth">
      {label} {optional && <span className="normal-case font-medium text-earth/50">(optional)</span>}
    </span>
    <input data-testid={testid} className={inputCls} {...props} />
  </label>
);

export const TextArea = ({ label, testid, optional, rows = 4, ...props }) => (
  <label className="block" data-testid={`${testid}-wrap`}>
    <span className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-earth">
      {label} {optional && <span className="normal-case font-medium text-earth/50">(optional)</span>}
    </span>
    <textarea data-testid={testid} rows={rows} className={`${inputCls} resize-y`} {...props} />
  </label>
);

export const Select = ({ label, testid, optional, options, ...props }) => (
  <label className="block" data-testid={`${testid}-wrap`}>
    <span className="mb-2 block text-xs font-bold uppercase tracking-[0.18em] text-earth">
      {label} {optional && <span className="normal-case font-medium text-earth/50">(optional)</span>}
    </span>
    <select data-testid={testid} className={`${inputCls} appearance-none`} {...props}>
      <option value="">Select one…</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </label>
);

export const SubmitButton = ({ children, testid, busy }) => (
  <button
    data-testid={testid}
    type="submit"
    disabled={busy}
    className="group inline-flex items-center justify-center gap-2 rounded-full bg-terracotta px-10 py-4 text-sm font-bold uppercase tracking-widest text-cream transition-all duration-300 hover:scale-[1.04] hover:bg-earth disabled:opacity-60 disabled:hover:scale-100"
  >
    {busy ? "Sending…" : children}
  </button>
);
